module.exports = __webpack_public_path__ + "img/add-photo-seventh-icon.a4b38028.svg";